import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { Table, TableCell } from './table.component.types';

@Component({
  selector: 'app-table',
  imports: [CommonModule, NgxPaginationModule],
  templateUrl: './table.component.html',
  styleUrl: './table.component.css'
})
export class TableComponent {

  @Input() content: Table = { headers: [], rows: [], numberOfElements: 10, number: 0, totalElements: 10 };
  @Input() enablePagination: boolean = true;
  @Output() rowClick = new EventEmitter<any>();
  @Output() pageChange = new EventEmitter<number>();

  onRowClick(id: any): void {
    this.rowClick.emit(id);
  }

  executeCallback(cell: TableCell, event: Event): void {
    if (cell.callback) {
      event.stopPropagation();
      cell.callback();
    }
  }

  onPageChange(page: number): void {
    this.pageChange.emit(page);
  }
}